import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";

const SchoolUsers = ({ schoolId }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      const db = getFirestore();
      let schoolIdToUse = schoolId;

      if (!schoolIdToUse) {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            schoolIdToUse = userDoc.data().school_id;
          }
        }
      }

      // Ensure schoolIdToUse is a string
      schoolIdToUse = String(schoolIdToUse);

      if (schoolIdToUse) {
        const q = query(
          collection(db, "users"),
          where("school_id", "==", schoolIdToUse),
        );
        const querySnapshot = await getDocs(q);
        const usersData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setUsers(usersData);
      } else {
        console.log("No schoolIdToUse found");
      }

      setLoading(false);
    };

    fetchUsers();
  }, [schoolId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Card>
      <CardHeader
        title="School Users"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        <AppDataGrid
          rows={users}
          columns={[
            { field: "name", headerName: "Name", flex: 1 },
            { field: "email", headerName: "Email", flex: 1 },
            { field: "title", headerName: "Title", flex: 1 },
          ]}
          pageSize={10}
          slots={{ toolbar: GridToolbarNoExport }}
          rowsPerPageOptions={[10, 25, 50]}
          components={{ Toolbar: GridToolbarNoExport }}
          autoHeight
        />
      </CardContent>
    </Card>
  );
};

export default SchoolUsers;
